<template>
  <div style="display:grid; min-height:100vh;">
    <!-- <loading
          :active.sync="isLoading"
          :can-cancel="false"
          loader="dots"
          :is-full-page="fullPage"
          :height="height"
          :width="width"
          background-color="#6b6969"
        ></loading>-->
    <green-nav />
    <div class="section section-basic mt-5 bg-light">
      <div class="custom-container-fluid">
        <div class="row">
          <div v-if="isLoading" class="col-md-12">
            <div class="row">
              <div class="col-md-4 col-lg-3" v-for="(e, i) in 4" :key="i">
                <div class="card mb-3">
                  <div class="card-body">
                    <div class="photo shine"></div>
                    <div class="lines shine" />
                    <div class="lines shine" />
                    <div class="lines shine" />
                    <div class="lines shine" />
                    <div class="lines shine" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="col-md-12">
            <div class="row">
              <div class="col-md-4 col-lg-3" v-for="(e, i) in events" :key="i">
                <div class="card">
                  <img :src="e['image']" class="card-img-top" alt="..." />
                  <!--              <span class="b-items__cars-one-img-type">Free</span>-->
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-3 col-lg-2 pr-0 pl-0">
                        <h4
                          class="mt-0 mb-0 font-weight-bold text-green sm-none"
                        >
                          {{ formatDate(e.date) }}
                        </h4>
                        <h6
                          class="mt-0 mb-0 font-weight-bold text-green md-none"
                        >
                          <span>{{ getFullDate(e.date) }} @ {{ e.time }}</span>
                        </h6>
                      </div>
                      <div
                        class="col-md-9 col-lg-10 pl-0 pr-0 mt-1 font-weight-bold text-capitalize"
                      >
                        {{ e.title }}
                      </div>
                    </div>
                    <div class="row">
                      <div
                        class="col-md-3 col-lg-2 pr-0 pl-0 d-none d-sm-block d-md-block d-lg-block"
                      >
                        <h3 class="font-weight-bold mt-0 sm-none">
                          {{ getDayFromDate(e.date) }}
                        </h3>
                      </div>
                      <div class="col-md-9 col-lg-10 pl-0 pr-0">
                        {{
                          (e.description || "").length > 200
                            ? (e.description || "").substring(0, 200) + "..."
                            : ""
                        }}
                      </div>
                      <div class="col-12 text-center mt-2" v-if="e.link">
                        <a
                          target="_blank"
                          :href="e.link"
                          class="btn btn-orange btn-sm"
                        >
                          Register to attend
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import Swal from "sweetalert2";
import GreenNav from "../components/navbar_green";
import downFooter from "../components/footer";
import axios from "axios";
export default {
  data() {
    return {
      isLoading: false,
      fullPage: true,
      height: 128,
      width: 128,
      events: []
    };
  },
  components: {
    // Loading,
    downFooter,
    GreenNav
  },

  methods: {
    formatDate(d) {
      return moment(d).format("MMM");
    },
    getDayFromDate(d) {
      return d ? moment(d).format("D") : "";
    },
    getFullDate(d) {
      return d ? moment(d).format("DD MMM YYYY") : "";
    },
    getEvents() {
      this.isLoading = true;
      axios
        .get(
          "https://ladies-in-tech-webservice.azurewebsites.net/all-activities"
        )
        .then(res => {
          const { data } = res;
          this.events = data.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  created() {
    this.$loadScript(
      "https://cdn.jsdelivr.net/npm/moment@2.27.0/min/moment.min.js"
    ).then(() => {
      this.getEvents();
    });
    document.body.style.background = "#ffffff";
  }
};
</script>

<style scoped>
.b-items__cars-one-img-type {
  border-radius: 5px;
  font: 700 10px "Open Sans", sans-serif;
  padding: 2px 5px;
  text-transform: uppercase;
  position: absolute;
  /* top: 15px; */
  z-index: 1000;
  background: white;
  top: 20px;
  left: 20px;
}
@media screen and (max-width: 768px) {
  .sm-none {
    display: none;
  }
}
@media screen and (min-width: 769px) {
  .md-none {
    display: none;
  }
}
</style>
